import { useEffect, useRef, useState } from 'react'

import {
  differenceInMilliseconds,
  fromUnixTime,
  intervalToDuration,
  isFuture,
} from 'date-fns'

export const useCountdown = (targetDate = 0) => {
  const intervalId = useRef(0)
  const [remainingEventTime, setRemainingEventTime] =
    useState<Nullable<Duration>>(null)

  const getRemainingTime = (startTime: Date) =>
    intervalToDuration({ start: new Date(), end: startTime })

  useEffect(() => {
    intervalId && clearInterval(intervalId.current)
    const startTime = fromUnixTime(targetDate)
    if (isFuture(startTime)) {
      const remainingTime = getRemainingTime(startTime)

      setRemainingEventTime(remainingTime)
      intervalId.current = window.setInterval(() => {
        const diff = differenceInMilliseconds(startTime, new Date())
        const remainingTime = getRemainingTime(startTime)

        setRemainingEventTime(diff >= 0 ? remainingTime : null)
        diff < 0 && clearInterval(intervalId.current)
      }, 1000)
    }
    return () => {
      clearInterval(intervalId.current)
      setRemainingEventTime(null)
    }
  }, [targetDate])

  return remainingEventTime
}
